import React from 'react';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES, WhiteModal } from '@sm360/widget-commons-general';

import SignUpContent from 'login/components/SignUp/SignUpContent/SignUpContent.jsx';

import { useMediaQuery } from 'react-responsive';

import { SIGN_UP as MODAL } from 'login/constants/modalNames.js';

import 'login/components/SignUp/SignUpModal.scss';

const czGroupName = 'widget.login.forms.signup';
const SignUpModal = () => {
    const modalBackgroundImageUrl =
        ContentZonesService.getContentZone(czGroupName, 'background') &&
        ContentZonesService.getContentZone(czGroupName, 'background').getValue();

    const isMobile = useMediaQuery({ query: `(max-width: ${MEDIA_QUERIES.MOBILE.MAX}px)` });
    const classParam = isMobile ? 'is-scrollable' : '';

    return (
        <WhiteModal
            name={MODAL}
            contentLabel="dialog with form for Sign up"
            className="widget-register-popupElement"
            isScrollable
            isClosable
            backgroundImage={modalBackgroundImageUrl}
        >
            <SignUpContent classParam={classParam} />
        </WhiteModal>
    );
};

SignUpModal.displayName = 'SignUpModal';

export default SignUpModal;
